import { env } from 'config/env';

import { openOnNewTab } from 'utils/html';

type SampleProjectPage = 'edit' | 'stats' | 'status-change';

const urlBuilders: Record<SampleProjectPage, (id: string) => string> = {
  'status-change': (id) => `${env.sampleUrl}/project/changestatus/${id}`,

  edit: (id) => `${env.sampleUrl}/project/edit/${id}`,

  stats: (id) => `${env.sampleUrl}/project/stats/${id}`,
};

export function getSampleProjectUrl(id: string, page: SampleProjectPage) {
  return urlBuilders[page](id);
}

export function openSampleProjectUrl(id: string, page: SampleProjectPage) {
  openOnNewTab(getSampleProjectUrl(id, page));
}
